import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { BillingOrder } from 'src/app/models/billingorder.model';
import { LeaseStatus, LeaseType, OrderType, StatusReason } from 'src/app/models/constants';
import { Lease } from 'src/app/models/lease.model';
import { TableColumn } from 'src/app/models/table-columns';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { RouterService } from 'src/app/services/router.service';

class ConditionalThankYou {
  public monthlyBilling: boolean | undefined;
  public payNow: boolean | undefined;
  public monthlyInvoiceManualPay: boolean | undefined;
  public renew: boolean | undefined;
  public renew1Plus12: boolean | undefined;
  public renewDirecttoMB: boolean | undefined;
  public renewIntoMB: boolean | undefined;
  public renew1Plus12TooLate: boolean | undefined;
  public bulkRenew: boolean | undefined;
}

@Component({
  selector: 'app-application-thank-you',
  templateUrl: './application-thank-you.component.html',
  styleUrls: ['./application-thank-you.component.scss']
})
export class ApplicationThankYouComponent extends ScrBaseComponent implements OnInit {

  public tableColumn: TableColumn[] = [
    { field: 'scId', width: '3' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '3' },
    { field: 'autoRenew', width: '3' },
    { field: 'listPrice', width: '3' },
    { field: 'price', width: '3' }
  ];
  public discountedTableColumn: TableColumn[] = [
    { field: 'scId', width: '3' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '3' },
    { field: 'autoRenew', width: '3' },
    { field: 'listPrice', width: '3' },
    { field: 'discount', width: '5' },
    { field: 'price', width: '3' }
  ];
  public pendingOrder: BillingOrder = new BillingOrder();
  public leaseApplicationData!: Lease;
  public conditionalTextObject: ConditionalThankYou = new ConditionalThankYou();
  public orderId!: number;
  public orderIds!: string;
  public orderType!: string;
  public availableCredit?: number;
  public monthlyInvoiceId!: number;
  public installments!: number;


  constructor(private routerService: RouterService, private scService: ShortCodesService, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.orderId = Number(this.route.snapshot.paramMap.get('orderId'));
    this.orderIds = String(this.route.snapshot.paramMap.get('orderId'));

    const previousPath = this.routerService.getPreviousUrl();

    this.availableCredit = history?.state?.availableCredit;
    if (!previousPath.includes("order-code-tab:payment")) {
      this.availableCredit = undefined;
    }

    this.localizeTableColumns(this.tableColumn);
    const orderIdsArray: number[] = [];
    this.orderIds
      .split(',')
      .forEach((val) => orderIdsArray.push(Number(val)));
    if (orderIdsArray.length > 1) {
      this.scService.getOrders(orderIdsArray).subscribe((resp) => {
        const orderIdColumn = { field: 'orderId', width: '3' };
        this.tableColumn.unshift(orderIdColumn);
        this.localizeTableColumns(this.tableColumn);
        const allOrderLeases: Lease[] = [];
        let totalPrice = 0;
        resp.order.forEach((order: BillingOrder) => {
          totalPrice += order.totalPrice;
          allOrderLeases.push(...order.leases);
        });
        this.pendingOrder.leases = allOrderLeases;
        this.pendingOrder.billingFirstName = resp.order[0].billingFirstName;
        this.pendingOrder.billingLastName = resp.order[0].billingLastName;
        this.pendingOrder.billingAddress1 = resp.order[0].billingAddress1;
        this.pendingOrder.billingAddress2 = resp.order[0].billingAddress2;
        this.pendingOrder.billingCountry = resp.order[0].billingCountry;
        this.pendingOrder.billingState = resp.order[0].billingState;
        this.pendingOrder.billingCity = resp.order[0].billingCity;
        this.pendingOrder.billingZip = resp.order[0].billingZip;
        this.pendingOrder.billingPhone = resp.order[0].billingPhone;
        this.pendingOrder.billingPhoneExtension =
          resp.order[0].billingPhoneExtension;
        this.pendingOrder.billingEmail = resp.order[0].billingEmail;
        this.pendingOrder.totalPrice = totalPrice;

        const sortedLeases = [...this.pendingOrder.leases].sort((a, b) => a.scId - b.scId);
        this.leaseApplicationData = sortedLeases[0];
        const bulkFound = this.pendingOrder.leases[0].misc;
        this.conditionalTextObject.renew =
          resp.order[0].applicationType == 'Renew';
        this.conditionalTextObject.bulkRenew =
          bulkFound && bulkFound === 'bulkRenewPayLater' ? true : false;
        this.conditionalTextObject.monthlyInvoiceManualPay = false;

        let isDiscounted = this.pendingOrder.leases.find((lease) => {
          if (lease.discountAmount && lease.discountAmount > 0)
            return lease.discountAmount > 0;
          else return false;
        });
        isDiscounted = this.pendingOrder.leases.find((lease) => {
          if (lease.discountList && lease.discountList.length > 0)
            return lease.discountList.length > 0;
          else return false;
        });
        if (isDiscounted) {
          const orderIdColumn = { field: 'orderId', width: '3' };
          this.tableColumn = this.discountedTableColumn;
          this.tableColumn.unshift(orderIdColumn);
          this.localizeTableColumns(this.tableColumn);
        }
      });
    } else {
      this.scService.getOrder(this.orderId).subscribe((rsp) => {
        this.pendingOrder = rsp.order;
        this.pendingOrder.leases.sort((a, b) => a.orderId - b.orderId);

        if (this.pendingOrder) {
          if (rsp.renewalDeadLineStr)
            this.pendingOrder.renewalDeadLineStr = rsp.renewalDeadLineStr;
          if (rsp.monBillStartDateStr)
            this.pendingOrder.monBillStartDateStr = rsp.monBillStartDateStr;
          let isDiscounted = rsp.order.leases.find((lease) => {
            if (lease.discountAmount && lease.discountAmount > 0)
              return lease.discountAmount > 0;
            else return false;
          });
          isDiscounted = rsp.order.leases.find((lease) => {
            if (lease.discountList && lease.discountList.length > 0)
              return lease.discountList.length > 0;
            else return false;
          });
          if (isDiscounted) {
            this.tableColumn = this.discountedTableColumn;
            this.localizeTableColumns(this.tableColumn);
          }
          if (rsp.order['monthlyInvoiceId'])
            this.monthlyInvoiceId = rsp.order['monthlyInvoiceId'];
          if (rsp.order.orderType) this.orderType = rsp.order['orderType'];
          if (
            this.orderType &&
            this.orderType === OrderType.BilledMonthly &&
            this.monthlyInvoiceId &&
            this.monthlyInvoiceId !== undefined
          ) {
            this.conditionalTextObject.monthlyInvoiceManualPay = true;
          } else {
            this.leaseApplicationData = this.pendingOrder.leases[0];
            this.conditionalTextObject.monthlyBilling =
              this.pendingOrder.leases[0].addToMb;
            this.conditionalTextObject.payNow =
              this.pendingOrder.leases[0].leaseStatus ===
                LeaseStatus.PendingNew ||
                this.pendingOrder.leases[0].leaseStatus ===
                LeaseStatus.PendingRenew
                ? false
                : true;
            //Handle Cancelled order getting renewed with paylater)
            if (
              this.pendingOrder.applicationType === 'Renew' &&
              this.pendingOrder.leases[0].leaseStatus ===
              LeaseStatus.Cancelled &&
              this.pendingOrder.leases[0].statusReason === StatusReason.NoPay
            )
              this.conditionalTextObject.payNow = false;

            //Handle special 2 rows case in 1+12 remew MB paylater
            if (
              this.pendingOrder.applicationType === 'Renew' &&
              this.pendingOrder.leases.length === 2 &&
              this.pendingOrder.leases[1].term === 1 &&
              (this.pendingOrder.leases[1].leaseStatus ===
                LeaseStatus.PendingRenew ||
                (this.pendingOrder.leases[1].leaseStatus ===
                  LeaseStatus.Cancelled &&
                  this.pendingOrder.leases[1].statusReason ===
                  StatusReason.NoPay))
            )
              this.conditionalTextObject.payNow = false;

            this.conditionalTextObject.monthlyInvoiceManualPay = false;
          }
          this.conditionalTextObject.renew =
            this.pendingOrder.applicationType == 'Renew';
          if (this.conditionalTextObject.renew) {
            this.conditionalTextObject.renewDirecttoMB =
              this.pendingOrder.leases[0].leaseType ===
                LeaseType.BilledMonthly && this.pendingOrder.leases.length === 1
                ? true
                : false;
            if (
              this.conditionalTextObject.renewDirecttoMB &&
              this.pendingOrder.startDate
            ) {
              const startDate = new Date(this.pendingOrder.startDate);
              this.pendingOrder.invoiceDate = new Date(
                startDate.getFullYear(),
                startDate.getMonth(),
                1
              );
              this.installments = this.pendingOrder.totalPrice / 12;
            }
            if (!this.conditionalTextObject.renewDirecttoMB) {
              //renew1plus12 = it is prepay and term is 1
              this.conditionalTextObject.renew1Plus12 =
                this.pendingOrder.leases.length === 2 &&
                  this.pendingOrder.leases[1]?.term === 1
                  ? true
                  : false;
              if (
                this.pendingOrder.leases.length === 1 &&
                this.pendingOrder.leases[0]?.term === 1
              ) {
                this.conditionalTextObject.renew1Plus12TooLate = this
                  .pendingOrder.leases[0].addToMb
                  ? false
                  : true;
              }
            }

            if (
              !this.conditionalTextObject.renewDirecttoMB &&
              !this.conditionalTextObject.renew1Plus12 &&
              !this.conditionalTextObject.renew1Plus12TooLate
            ) {
              const bulkFound = this.pendingOrder.leases[0].misc;
              console.log('Bulk found = ' + bulkFound);
              this.conditionalTextObject.bulkRenew =
                bulkFound && (bulkFound === 'bulkRenew' || bulkFound === 'bulkRenewPayLater') ? true : false;
              if (bulkFound === 'bulkRenewPayLater') {
                const orderIdColumn = { field: 'orderId', width: '3' };
                this.tableColumn.unshift(orderIdColumn);
                this.localizeTableColumns(this.tableColumn);
              }
            }
            this.conditionalTextObject.renewIntoMB =
              this.conditionalTextObject.renewDirecttoMB ||
              this.conditionalTextObject.renew1Plus12;
          }
        }
        return false;
      });
    }
  }

  downloadReceiptPdf() {
    this.clearMessages();

    let filename = this.conditionalTextObject.renew || this.pendingOrder.applicationType == 'New'
      ? `ShortCode_Receipt_${this.orderId}.pdf`
      : `Receipt_${this.orderId}.pdf`;
    filename = this.conditionalTextObject.monthlyInvoiceManualPay // MB should have MonthlyReceipt
      ? `ShortCode_MonthlyReceipt_${this.orderId}.pdf`
      : filename;
    const po = this.createDownloadPartialObserver('application/pdf', filename);
    this.scService.getReceiptPdf(this.orderId).subscribe(po);
  }

  downloadInvoicePdf() {
    this.clearMessages();

    const filename = this.conditionalTextObject.renew || this.pendingOrder.applicationType == 'New'
      ? `ShortCode_Invoice_${this.orderId}.pdf`
      : `Invoice_${this.orderId}.pdf`;
    const po = this.createDownloadPartialObserver('application/pdf', filename);
    this.scService.getInvoicePdf(this.orderId).subscribe(po);
  }

  getDiscountList(lease: Lease) {
    if (!lease.discountList || lease.discountList.length === 0) {
      return '';
    }
    else {
      return lease.discountList.map(disc => disc.displayName).join(', ');
    }
  }

}
